import {HINT_IGNORE_ATT, HintGlobal, HintGroupAnnot, HintsState, HintTextAnnot, IHintFamilyModel, IHintMsg, serializeHintIgnore} from "/@lib@/edit/ot/hints.js";
import {IDocHolderSync} from "/@lib@/edit/docHolder.js";
import {IReg, REG} from "/@lib@/commons/registry.js";
import {DOM, JSX, ShadowJsx} from "/@lib@/commons/xml/dom.js";
import {Button, OButtonInit} from "/@back@/commons/widgets/buttons.js";
import {XA} from "/@lib@/commons/xml/xAddr.js";
import {POPUP} from "/@back@/commons/widgets/popups.js";
import {CDM} from "/@lib@/commons/utils/cdm.js";
import {ICoreUniverseEnv} from "/@lib@/core/universe.js";
import {FORMS} from "/@lib@/commons/forms.js";
import {ERROR} from "/@lib@/core/errorReport.js";
import {IO} from "/@lib@/commons/io/io.js";
import "/@lib@/core/core_Perms.js";


export class SpellLTHintFM implements IHintFamilyModel {
	key = "spell";
	label = "Orthographe et grammaire";
	isManual = true;

	completeMsg(m: IHintMsg) {
		if (m.type === HintGlobal.type) {
			switch (m.label) {
			case "serviceNotConfigured" :
				m.label = "Service de correction non configuré";
				break;
			case "serviceUnavailable" :
				m.label = "Service de correction indisponible";
				break;
			case "quotaReached" :
				m.label = "Votre quota a été atteint, recommencez ultérieurement";
				break;
			case "authFailed" :
				m.label = "Le compte ou la clé d'accès au service de correction sont incorrects";
				break;
			case "langUnavailable" :
				m.label = "La langue n'est pas disponible ou une erreur de LanguageTool s'est produite";
				break;
			case "maxBodyReached" :
				m.label = "Certains paragraphes sont trop volumineux, seul le début a été évalué";
				break;
			}
		}
	}

	async buildDetails(hint: IHintSpell, docHodler: IDocHolderSync, reg: IReg<any>, uiFrom: HTMLElement): Promise<HTMLElement | null> {
		const repl = hint.metas?.replacements;
		//const me = this;
		const onReplace = function (this: HTMLButtonElement, ev: MouseEvent) {
			const groupHints = hint.metas?.group?.msgs;
			const firstH = groupHints?.[0] || hint;
			const lastH = groupHints?.[groupHints.length - 1] || hint;
			const batch = docHodler.newBatch({start: XA.freeze(firstH.start), end: XA.incrAtDepth(lastH.start, -1, lastH.len)})
			batch.spliceSequence(firstH.start, firstH.len, this.textContent);
			if (groupHints) for (let i = 1; i < groupHints.length; i++) {
				const h = groupHints[i];
				batch.deleteSequence(h.start, h.len);
			}
			batch.doBatch();
			POPUP.findPopupableParent(this)?.close();
		}

		const onIgnore = function (this: HTMLButtonElement, ev: MouseEvent) {
			const start = XA.freeze(hint.start);
			let elt = XA.findDomContainer(start, docHodler.getDocument()).parentElement;
			if (elt) {
				const qs = new URLSearchParams(elt.getAttribute(HINT_IGNORE_ATT) || "");
				const spellsIgnore = qs.getAll(SPELL_KEY);
				const value = CDM.stringify(hint.metas.term);
				if (!hint.ignore) {
					//On ajoute
					if (spellsIgnore.indexOf(value) < 0) qs.append(SPELL_KEY, value)
				} else {
					//On retire
					qs.delete(SPELL_KEY)
					for (const v of spellsIgnore) {
						if (v !== value) qs.append(SPELL_KEY, v)
					}
				}
				const batch = docHodler.newBatch().setSelBefore(start).setSelAfter(start);
				batch.setAttr(XA.setAtDepth(XA.up(start), -1, HINT_IGNORE_ATT), serializeHintIgnore(qs) || null /*suppr att si ""*/);
				batch.doBatch();
				docHodler.house.getStateById<HintsState>(HintsState.type).setHintIgnore(hint, !hint.ignore);
			}
			POPUP.findPopupableParent(this)?.close();
		}
		const replArea = repl ? <div class="repl">
			{hint.metas?.replacements?.map((r: string) => <c-button class="opt" onclick={onReplace}>{r}</c-button>)}
		</div> : undefined
		const type = hint.metas?.spellType;
		return <div>
			<ShadowJsx skin="webzone:panel" skinOver="HintSpellLT">
				<header>{type === "misspelling" ? "Orthographe" : type === "style" ? "Style" : "Grammaire"}</header>
				<h4>{hint.getLabel()}</h4>
				{replArea}
				<div class="actions">
					{hint.metas.term ?
						<c-button î={{label: hint.ignore ? "Restaurer ce conseil ici" : "Ignorer ce conseil ici", uiContext: "dialog"} satisfies OButtonInit} onclick={onIgnore}/>
						: undefined
					}
					{/*{type === "misspelling" ? <c-button î={{label: "Ajouter au dictionnaire", uiContext: "dialog"} satisfies OButtonInit}></c-button> : undefined}*/}
				</div>
				<div class="ltMark">Powered by LanguageTool</div>
			</ShadowJsx>
		</div>
	}
}

interface IHintSpell extends HintTextAnnot {
	metas?: {
		term?: string
		replacements?: string[]
		spellType?: "style" | "misspelling" | string
		group?: HintGroupAnnot
	}
}

const SPELL_KEY = "spell"

REG.reg.registerSkin("HintSpellLT", 1, /* language=CSS */ `
	:host {
		padding: .5em;
	}

	header {
		font-style: italic;
		color: var(--alt1-color);
	}

	h4 {
		margin: .5rem 0;
	}

	.repl, .actions {
		margin-top: .5rem;
		display: flex;
		flex-wrap: wrap;
	}

  .opt {
	  background-color: var(--alt2-bgcolor);
	  font-size: 120%;
	  margin: 0.3em;
  }

  .opt:hover {
	  filter: var(--hover-filter);
  }

  .ltMark {
	  text-align: end;
	  font-size: .7em;
	  font-style: italic;
	  color: var(--info-color);
  }
`);


/**
 * A utiliser lorsque le service est configurable par l'auteur ou administrateur fonctionnel via une interface graphique.
 */
export class SpellLTConfigHintFM extends SpellLTHintFM {

	constructor(protected dynConfig?: boolean | null, protected hasDefaultConfig: boolean = false) {
		super();
	}

	/**
	 * Configurable si :
	 * - SOIT le svc java est configurable et le user a les permissions pour éditer cette config.
	 * - SOIT TODO le serveurLT pointé dispose d'une gestion d'un dictionnaire dédié éditable.
	 */
	async isConfigAvailable(reg: IReg<any>): Promise<boolean> {
		if (!reg.hasPerm("admin.spellLT")) return false;
		if (this.dynConfig === undefined) this.dynConfig = (await this.fetchConfig(reg)) != null
		return this.dynConfig;
	}

	async editConfig(reg: IReg<any>, uiCtx: HTMLElement): Promise<void> {
		function setInputsHidden(form: HTMLFormElement, hidden: boolean) {
			const inputs = form.querySelector("#inputs");
			DOM.setHidden(inputs, hidden);
		}

		const form = <form>
			<div class="modes">
				<label class="mode"><input type="radio" name="mode" value="undefined" onchange={function (this: HTMLInputElement) {
					if (!this.checked) return;
					const inputs = form.elements;
					setInputsHidden(form, true);
					(inputs.namedItem("url") as HTMLInputElement).value = "";
					(inputs.namedItem("userName") as HTMLInputElement).value = "";
					(inputs.namedItem("apiKey") as HTMLInputElement).value = "";
					(inputs.namedItem("maxLength") as HTMLInputElement).value = "";
				}}/>{this.hasDefaultConfig ? "Configuration par défaut" : "LanguageTool désactivé"}</label>
				<label class="mode"><input type="radio" name="mode" value="free" onchange={function (this: HTMLInputElement) {
					if (!this.checked) return;
					const inputs = form.elements;
					setInputsHidden(form, false);
					(inputs.namedItem("url") as HTMLInputElement).value = "https://api.languagetool.org";
					(inputs.namedItem("userName") as HTMLInputElement).value = "";
					DOM.setHidden(form.querySelector("#userNameEntry"), true);
					(inputs.namedItem("apiKey") as HTMLInputElement).value = "";
					DOM.setHidden(form.querySelector("#apiKeyEntry"), true);
					(inputs.namedItem("maxLength") as HTMLInputElement).value = "20000";
				}}/>Service LanguageTool gratuit</label>
				<label class="mode"><input type="radio" name="mode" value="premium" onchange={function (this: HTMLInputElement) {
					if (!this.checked) return;
					const inputs = form.elements;
					setInputsHidden(form, false);
					(inputs.namedItem("url") as HTMLInputElement).value = "https://api.languagetoolplus.com";
					DOM.setHidden(form.querySelector("#userNameEntry"), false);
					DOM.setHidden(form.querySelector("#apiKeyEntry"), false);
					(inputs.namedItem("maxLength") as HTMLInputElement).value = "60000";
				}}/>Service LanguageTool payant</label>
				<label class="mode"><input type="radio" name="mode" value="custom" onchange={function (this: HTMLInputElement) {
					if (!this.checked) return;
					const inputs = form.elements;
					setInputsHidden(form, false);
					(inputs.namedItem("url") as HTMLInputElement).value = "";
					(inputs.namedItem("userName") as HTMLInputElement).value = "";
					DOM.setHidden(form.querySelector("#userNameEntry"), false);
					(inputs.namedItem("apiKey") as HTMLInputElement).value = "";
					DOM.setHidden(form.querySelector("#apiKeyEntry"), false);
					(inputs.namedItem("maxLength") as HTMLInputElement).value = "20000";
				}}/>Serveur dédié</label>
			</div>
			<div id="inputs">
				<div class="ctrlLbl"><label class="lbl" for="url">URL du service LanguageTool</label><input id="url" name="endPoint" type="url" required=""/></div>
				<div class="ctrlLbl" id="userNameEntry"><label class="lbl" for="userName">Compte (Email)</label><input id="userName" name="userName" type="text"/></div>
				<div class="ctrlLbl" id="apiKeyEntry"><label class="lbl" for="apiKey">Clé d'accès (ApiKey)</label><input id="apiKey" name="apiKey" type="text"/></div>
				<div class="ctrlLbl"><label class="lbl" for="maxLength" title="Nombre de caractères maximum par requête au service (dépend du serveur)">Nombre de caractères max.</label><input id="maxLength" name="maxLength" type="number"
																																																																																														min="20000"/></div>
			</div>
		</form> as HTMLFormElement
		const data = await this.fetchConfig(reg);
		if (!data.endPoint) {
			data.mode = "undefined";
		} else if (data.endPoint === "https://api.languagetool.org") {
			data.mode = "free";
		} else if (data.endPoint === "https://api.languagetoolplus.com") {
			data.mode = "premium";
		} else {
			data.mode = "custom";
		}
		FORMS.jsonToForm(data, form, true, true);
		const me = this;
		const ct = <div>
			<ShadowJsx skin="SpellLTConfigHintFM/config" skinOver="webzone:panel form-control-areas standard-dialog">
				{form}
				<div id="footer">
					<c-button id="ok" label="Enregistrer" ui-context="dialog" onclick={function (this: Button) {me.saveConfig(FORMS.formToJson(form), reg, this)}}/>
					<c-button label="Fermer" ui-context="dialog" onclick={function (this: Button) {POPUP.findPopupableParent(this).close()}}/>
				</div>
			</ShadowJsx>
		</div>
		POPUP.showDialog(ct, uiCtx, {titleBar: "Configuration d'accès au serveur LanguageTool"});
	}

	protected async saveConfig(data: IDynConfigLT, reg: IReg<ICoreUniverseEnv>, uiCtx: HTMLElement) {
		try {
			if (data.mode === "undefined")
				data = null;
			await reg.env.universe.httpFrames.web.fetchSvc("u/spellchecker", "Configure", null, "none", {
				method: "POST",
				headers: {"Content-Type": "application/x-www-form-urlencoded"},
				body: IO.query(null, "param", data ? JSON.stringify(data) : null)
			});
			POPUP.findPopupableParent(uiCtx)?.close();
		} catch (e) {
			ERROR.report("Echec à l'enregistrement de cette configuration.", e)
		}
	}


	protected async fetchConfig(reg: IReg<ICoreUniverseEnv>): Promise<null | IDynConfigLT> {
		try {
			return (await reg.env.universe.httpFrames.web.fetchSvcJson<{ dynConfLT: null | IDynConfigLT }>("u/spellchecker", "FetchConfig")).dynConfLT || null;
		} catch (e) {
			return null;
		}
	}
}

REG.reg.registerSkin("SpellLTConfigHintFM/config", 1, /* language=CSS */ `
	form {
		padding: .5em;
		min-height: 11em;
	}

	.modes {
		margin-block: 1em;
	}

	.mode {
		padding-inline: .5em;
		color: var(--alt1-color);
		user-select: none;
	}

	.lbl {
		min-width: 15em !important;
	}
`);

interface IDynConfigLT {
	endPoint?: string
	apiKey?: string
	dicts?: string
	maxLength?: number

	/** Usage local. */
	mode?: "undefined" | "free" | "custom" | "premium"
}